export default __webpack_public_path__ + "static/media/Pross-BG.c5d00335.webp";